import { connect } from "react-redux";
import ListMediaComponent from "../../Components/Medias/ListMediaComponent";
import { setMedias } from "../../Redux/Actions/MediaActions";
const mapStateToProps = (state) => ({
    MEDIAS: state.reducer.MEDIAS,
    ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
    SCOPES_NAMES: state.reducer.SCOPES_NAMES,
   
});
const mapDispatchToProps = (dispatch) => ({
  setMedias: (MEDIAS) => dispatch(setMedias(MEDIAS)),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(ListMediaComponent);